export const composeLeftFunction =
  <E>(...args: ReadonlyArray<(arg: E) => E>) =>
  (input: E) =>
    args.reduce((intermediaryResult, func) => func(intermediaryResult), input);
